/* eslint-disable spaced-comment */
export default {
  dbh_calendar_year: '年份',
  dbh_calendar_month: '月份',

  /**** 月份 ****/
  dbh_january: '1月',
  dbh_february: '2月',
  dbh_march: '3月',
  dbh_april: '4月',
  dbh_may: '5月',
  dbh_june: '6月',
  dbh_july: '7月',
  dbh_august: '8月',
  dbh_september: '9月',
  dbh_october: '10月',
  dbh_november: '11月',
  dbh_december: '12月',
  /**** 月份 ****/

  /**** 周 ****/
  dbh_monday: '一',
  dbh_tuesday: '二',
  dbh_wednesday: '三',
  dbh_thursday: '四',
  dbh_friday: '五',
  dbh_saturday: '六',
  dbh_sunday: '日',
  /**** 周 ****/

  dbh_more: '更多',
  dbh_today: '今天',
  dbh_week_monday: '周一',
  dbh_week_tuesday: '周二',
  dbh_week_wednesday: '周三',
  dbh_week_thursday: '周四',
  dbh_week_friday: '周五',
  dbh_week_saturday: '周六',
  dbh_week_sunday: '周日',

};
